import React from 'react';
import PropTypes from 'prop-types';
import 'reset-css/reset.css';
import '../color/color';
import '../typography/typography';
import './pullquote.css';

const Pullquote = ({ text }) => <cite>{text}</cite>;

Pullquote.defaultProps = {
  text: '',
};

Pullquote.propTypes = {
  text: PropTypes.string,
};

export default Pullquote;
